export enum PromoType {
  bonus,
  service,
  contest,
  extras,
}

export enum PromoStatus {
  all,
  new,
  registration,
  process,
  ended,
  results,
  archived
}

export interface PromoImagesUrl {
  webURL: string;
  mobileURL: string;
}

export interface PromoBase {
  description?: string;
  name: string;
  title?: string;
  type: PromoType;
  promoImagesURL?: PromoImagesUrl;
}

export interface Promo extends PromoBase {
  status: PromoStatus;
  promoIdLegacy?: string;
  registration_time?: string;
  results_time?: string;
  sort_weight: number;
  archive_time?: string;
  end_time?: string;
  start_time?: string;
  actions?: [];
  widgetImageURL?: string;
}

export enum knownPromos {
  vps = 'vps'
}

export interface ArchivedPromo extends PromoBase {
  archive_time: string;
  end_time: string;
  start_time: string;
  start_timestamp: number;
  end_timestamp: number;
  promo_id: number;
  year: number;
}
